<template>
    <router-view />
</template>
<script>
export default {
    /* @71139 */
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-fasefenologica') {
            next({ name: 'agro-fasefenologica-list' });
        } else if (to.name == 'ven-fasefenologica') {
            next({ name: 'ven-fasefenologica-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-fasefenologica') {
            this.$router.push({ name: 'agro-fasefenologica-list' });
        } else if (this.$route.name == 'ven-fasefenologica') {
            this.$router.push({ name: 'ven-fasefenologica-list' });
        }
    },
};
</script>
